import { SerializedStyles, css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IStyledNavigationItemWrapperProps {
  folded: boolean;
  hasChildren: boolean;
}

export const StyledNavigationItemWrapper = styled.li<IStyledNavigationItemWrapperProps>`
  list-style: none;
  position: relative;
  overflow: hidden;

  > span,
  a {
    display: flex;
    align-items: center;
    padding: var(${SpacingToken.Spacing2}) 0;
    font-size: 14px;
    line-height: 21px;
    color: ${withVar(DesignToken.ContentBasicSecondary)};
    outline: none;
    text-decoration: none;
    transition: color 0.2s ease-in-out;
  }

  a:hover {
    color: var(${DesignToken.ActionPrimaryDefault});
  }

  > span {
    color: var(${DesignToken.ContentBasicSecondary});
  }

  > a.active {
    ${({ hasChildren }): SerializedStyles =>
      !hasChildren
        ? css`
            color: var(${DesignToken.ActionPrimaryDefault});
            font-weight: 600;
          `
        : css``};
    ${({ folded, hasChildren }): SerializedStyles =>
      folded && hasChildren
        ? css`
            color: var(${DesignToken.ActionPrimaryDefault});
          `
        : css``};
  }
`;

export const SubNavigation = styled.ul<{ folded: boolean }>`
  margin-left: 20px;
  height: 0;

  ${({ folded }): SerializedStyles =>
    !folded
      ? css`
          height: auto;
        `
      : css``};

  li {
    position: relative;
    > a.active {
      color: var(${DesignToken.ActionPrimaryDefault});
      font-weight: 600;
    }
  }
`;

interface IStyledChevronProps {
  rotated: boolean;
}

export const StyledChevron = styled.div<IStyledChevronProps>`
  position: absolute;
  z-index: 1;
  padding: 10px;
  top: 7px;
  right: 4px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  ${({ rotated }): SerializedStyles | string =>
    !rotated
      ? css`
          transform: rotate(-90deg);
        `
      : ""};
`;

interface IBadgeWrapper {
  padded: boolean;
}

export const BadgeWrapper = styled.span<IBadgeWrapper>`
  position: absolute;
  top: 8px;
  right: ${({ padded }): string => (padded ? "40px" : "10px")};
`;
